var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCrossIconHowToReadEyewear = function SvgCrossIconHowToReadEyewear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#crossIconHowToReadEyewear_svg__clip0_8266_78223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3 1.633l-.934-.934-6.867 6.867L1.633.699l-.934.934 6.867 6.866-6.867 6.867.934.933 6.866-6.866 6.867 6.866.933-.933-6.866-6.867 6.866-6.866z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crossIconHowToReadEyewear_svg__clip0_8266_78223"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCrossIconHowToReadEyewear;